const storeConfig = {
  to: 'https://rootstechonlinestore2026.itemorder.com/shop/home/',
}

export default storeConfig
